/* WF-047 · the two doors' frame (the connexion ruling 19/10): a page outside the shell and the mirror, one column, the
   brand mark on top. No session is needed here; lib/auth does the exchange, the screens say the sentences. */
import type { ReactNode } from 'react'

const WRAP = { minHeight: '100dvh', display: 'grid', placeItems: 'start center', padding: '56px 20px 40px', boxSizing: 'border-box' } as const
const COL = { width: '100%', maxWidth: 440, display: 'grid', gap: 18 } as const

export function Door({ children, testid }: { children: ReactNode; testid: string }) {
  return (
    <main style={WRAP} data-testid={testid}>
      <div style={COL}>
        <div className="side-brand" style={{ padding: 0 }}>
          <span className="side-mark" aria-hidden>b</span><span className="side-name" style={{ display: 'inline' }}>buildmyreviews</span>{/* the shell hides the name on narrow screens; a door says it */}
        </div>
        {children}
      </div>
    </main>
  )
}
